import React, { useState, useEffect, useContext, createContext } from 'react';
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  createUserWithEmailAndPassword,
  sendEmailVerification,
  fetchSignInMethodsForEmail,
  updateProfile,
  OAuthProvider
} from 'firebase/auth';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import { setLocalStorage } from '../app/common/utils';
// import { useMutation } from 'react-query';
import axios from 'axios';

const firebaseConfig = {
  apiKey: 'AIzaSyCRz7s8jGdVoi7VUUN1psYQJGgbICin_OY',
  authDomain: 'tlsa-62b9a.firebaseapp.com',
  databaseURL: 'https://tlsa-62b9a.firebaseio.com',
  projectId: 'tlsa-62b9a',
  storageBucket: 'tlsa-62b9a.appspot.com',
  messagingSenderId: '220969364008',
  appId: '1:220969364008:web:e33087bc4181bd58e0231d',
  measurementId: 'G-EEP3ME01X2'
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);
const urlAppleFirebase = 'https://tlsa-62b9a.firebaseapp.com/__/auth/handler';

const authContext = createContext();

function useProvideAuth() {
  const [user, setUser] = useState(null);
  const [isFirebaseDown, setIsFirebaseDown] = useState(false);

  const handleFirebaseError = (error) => {
    if (error?.code === 'auth/network-request-failed') {
      setIsFirebaseDown(true);
      return { error: 'firebase-down' };
    }
    return { error: error?.code };
  };
  // Wrap any Firebase methods we want to use making sure ...
  // ... to save the user to state.

  const signin = (email, password) => {
    return signInWithEmailAndPassword(auth, email, password).catch((error) => {
      return handleFirebaseError(error);
    });
  };
  const signup = async (email, password, firstName, lastName) => {
    return await createUserWithEmailAndPassword(auth, email, password).then(async (response) => {
      const user = response.user;
      const displayName = `${firstName} ${lastName}`;
      await updateProfile(user, { displayName: displayName, email: email });
      setUser(user);
      return user;
    });
  };
  const signout = () => {
    return auth.signOut().then(() => {
      setUser(false);
    });
  };
  const sendPasswordResetByEmail = async (email) => {
    return await sendPasswordResetEmail(auth, email, {
      url: `${process.env.VITE_HOST}`
    }).then(() => {
      return true;
    });
  };
  const sendVerificationByEmail = async (storeUser) => {
    return await sendEmailVerification(user ? user : storeUser, {
      url: `${process.env.VITE_HOST}`
    }).then(() => {
      return true;
    });
  };
  const fetchSignInMethodsByEmail = async (email) => {
    return await fetchSignInMethodsForEmail(auth, email).then((methods) => {
      return methods.length === 0;
    });
  };
  const confirmPasswordReset = (code, password) => {
    return auth.confirmPasswordReset(code, password).then(() => {
      return true;
    });
  };
  // Subscribe to user on mount
  // Because this sets state in the callback it will cause any ...
  // ... component that utilizes this hook to re-render with the ...
  // ... latest auth object.
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(
      (user) => {
        if (user) {
          setUser(user);
          setIsFirebaseDown(false);
        } else {
          setIsFirebaseDown(true);
        }
      },
      (error) => {
        if (error?.code === 'auth/network-request-failed') {
          setIsFirebaseDown(true);
        }
      }
    );
    // Cleanup subscription on unmount
    return () => unsubscribe();
  }, [auth]);
  // Return the user object and auth methods
  return {
    user,
    signin,
    signup,
    signout,
    sendPasswordResetByEmail,
    confirmPasswordReset,
    sendVerificationByEmail,
    fetchSignInMethodsByEmail,
    isFirebaseDown
  };
}

function ProvideAuth({ children }) {
  const auth = useProvideAuth();
  return <authContext.Provider value={auth}>{children}</authContext.Provider>;
}

const useAuth = () => {
  return useContext(authContext);
};

const handleEnableUser = async (token) => {
  try {
    const route = `/enable`;
    await axios.post(
      route,
      {
        firstName: '',
        lastName: ''
      },
      {
        headers: {
          Authorization: token
        }
      }
    );
    window.open('new_file', '_self');
  } catch (error) {
    console.error('error enabling user ..', error);
  }
};

const checksEmailVerification = (user) => {
  setLocalStorage('userData', user);
  setLocalStorage('token', user.accessToken);
  handleEnableUser(user.accessToken);
};

const nonEmailVerified = () => {
  window.open('/email_verification', '_self');
};

const provider = new GoogleAuthProvider();
const googleHandler = async () => {
  provider.setCustomParameters({ prompt: 'select_account' });
  signInWithPopup(auth, provider)
    .then((result) => {
      const user = result.user;
      setLocalStorage('email-login', user.email);
      if (user.emailVerified) {
        checksEmailVerification(user);
      } else {
        nonEmailVerified();
      }
    })
    .catch((error) => {
      // Handle Errors here.
      console.error('google error sign in/up', error);
    });
};

const appleProvider = new OAuthProvider('apple.com');
const appleHandler = async () => {
  appleProvider.addScope('email');
  appleProvider.addScope('name');
  // appleProvider.setCustomParameters({ prompt: 'select_account' });
  signInWithPopup(auth, appleProvider)
    .then((result) => {
      const user = result.user;
      setLocalStorage('email-login', user.email);
      if (user.emailVerified) {
        checksEmailVerification(user);
      } else {
        nonEmailVerified();
      }
    })
    .catch((error) => {
      // Handle Errors here.
      console.error('apple error sign in/up', error);
    });
};

export { useAuth, ProvideAuth, googleHandler, appleHandler };
